<template>
    <div class="statistica__summary-item-data  f-stat-data"
        :class="(sign < 0) ? 'f-stat-data--down ' + 'f-stat-data--type'+mod : 'f-stat-data--up ' + 'f-stat-data--type'+mod"
	>
        <i v-if="side === 'left'" :class="(sign < 0) ? 'icon-arrow-down' : 'icon-arrow-up'"
		   class="f-stat-data__icon"></i>{{units != 'q' ? units : ''}} {{getData}}
        <i v-if="side !== 'left'" :class="(sign < 0) ? 'icon-arrow-down' : 'icon-arrow-up'"
		   class="f-stat-data__icon"></i>
    </div>
</template>
<script>
import svgIcon from './svg-icon';
export default {
    props: {
        data:{default:0},
        units:{default:''},
        side:{default:'left'},
        iconWidth:{default:''},
		mod:{default: ''},
		"svg-icon":svgIcon
    },
    data() {
        return {
            sign:1
        }
    },
    computed: {
        getData() {
            if(this.units === '$')
                return this.$moneyf(this.data)
            else if(this.units === '%' || this.units === '')
                return this.data.toFixed(2)
            else if(this.units === 'q')
                return this.data
        }
    },
    watch: {
        data: function(newData, oldData) {
            this.sign = newData > oldData ? 1 : newData < oldData ? -1 : 0;
        }
    }
}
</script>
<style lang="less" scoped>
.statistica {
    &__summary {
        width: 912px;
        background-color: #324258;
        display: block;
        color: #fff;
        border-radius: 4px;
        margin-bottom: 40px;
        margin-top: 20px;
        &-item {
            border-bottom: 1px solid #293546;
            display: flex;
            justify-content: space-between;
            &-title {
                font-family: Montserrat;
                font-size: 16px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 3;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding: 0 12px;
            }
            &-data {
                    span {
                        margin-left:12px;
                    }

                    &-title {
                        font-family: Arimo;
                        font-size: 11px;
                        font-weight: bold;
                        font-style: normal;
                        font-stretch: normal;
                        line-height: 3.64;
                        letter-spacing: 0.4px;
                        text-align: left;
                        color: #adc7e1;
                        text-transform: uppercase;
                        padding-left: 12px;
                    }
                }
            }
        }

}
</style>

